import { createFeatureSelector, createSelector, defaultMemoize } from '@ngrx/store'
import { TaggingState } from './tagging.reducer'
import { CallStatus } from '../dashboard/calls.types'

const stateKey = 'tagging'

export const selectTaggingState = createFeatureSelector<TaggingState>(stateKey)

export const createSelectTaggedCallStatus = createSelector(
  selectTaggingState,
  (state: TaggingState) => defaultMemoize((callId: string) => state[callId])
)

export const createSelectIsCallStatusTagged = createSelector(
  createSelectTaggedCallStatus,
  (selectTaggedCallStatus) =>
    (callId: string, callStatus: CallStatus): boolean =>
      callStatus === selectTaggedCallStatus.memoized(callId)
)
